import {
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Stack,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useAppContext } from "../../contexts/AppContext";
import { cutOffText } from "../../utils";

export const Breadcrumbs: React.FC = () => {
  const { breadcrumbs } = useAppContext();

  if (!breadcrumbs || breadcrumbs.length === 0) return null;

  return (
    <Box
      sx={{
        pt: 2,
        mt: 1,
        mb: 1,
        display: "flex",
        justifyContent: "flex-start",
      }}
    >
      <MuiBreadcrumbs
        separator={
          <Typography
            sx={{ color: "rgba(0, 0, 0, 0.40)" }}
            fontSize={12}
            variant="body1"
          >
            /
          </Typography>
        }
        aria-label="breadcrumb"
      >
        {breadcrumbs.map((breadcrumb, index) => (
          <Stack direction="row" spacing={1} key={index}>
            {breadcrumb.icon ? breadcrumb.icon : null}
            {breadcrumb.href ? (
              <Link
                style={{ textDecoration: "none", color: "rgba(0, 0, 0, 0.40)" }}
                to={breadcrumb.href}
                key={index}
              >
                <Typography
                  sx={{ color: "rgba(0, 0, 0, 0.40)" }}
                  variant="body1"
                >
                  {cutOffText(breadcrumb.label, 120)}
                </Typography>
              </Link>
            ) : (
              <Typography
                variant="body1"
                color={index === breadcrumbs.length - 1 ? "black" : "inherit"}
                key={index}
              >
                {cutOffText(breadcrumb.label, 120)}
              </Typography>
            )}
          </Stack>
        ))}
      </MuiBreadcrumbs>
    </Box>
  );
};
